import { Container } from '@components';
import HnaviLogo from '@images/hnavi-logo.png';
import ItMediaLogo from '@images/itmedia-logo.png';
import { adSaasPath, developerEntryPath } from '@paths';

const Separator: React.FC = () => (
  <span className='mx-3 inline-block text-gray-ccc'>|</span>
);

const Link: React.FC<{ href: string }> = ({ children, href }) => (
  <a href={href} className='text-top-primary hover:text-primary'>
    {children}
  </a>
);

const Item: React.FC<{ noSeparator?: boolean; href: string }> = ({
  noSeparator,
  href,
  children,
}) => (
  <li className='mr-2'>
    <Link href={href}>{children}</Link>
    {noSeparator || <Separator />}
  </li>
);

export const Footer: React.FC = () => {
  return (
    <footer className='bg-accent-1 border-accent-2 w-full border-t border-gray py-4'>
      <Container>
        <div className='mh-[110px] mx-auto flex max-w-7xl flex-col items-center justify-between lg:flex-row'>
          <div className='flex items-center justify-center'>
            <div className='shrink-0 lg:mr-7'>
              <a href='/' className='block w-[200px] lg:w-[180px]'>
                <img
                  src={HnaviLogo.src}
                  alt='発注ナビ'
                  width={HnaviLogo.width}
                  height={HnaviLogo.height}
                />
              </a>
            </div>
            <ul className='hidden lg:flex lg:flex-wrap'>
              <Item href='/about_us/'>運営会社</Item>
              <Item href='/faq/'>よくあるご質問</Item>
              <Item href='/tos/'>利用規約</Item>
              <Item href='/privacy/'>プライバシーポリシー</Item>
              <li className='mr-2'>
                掲載のご案内（
                <Link href={developerEntryPath}>開発会社向け</Link> /{' '}
                <Link href={adSaasPath}>SaaSベンダー向け</Link>）
              </li>
              <Item href='/inquiry/' noSeparator>
                お問い合わせ
              </Item>
            </ul>
          </div>
          <div className='text-right'>
            <div className='hidden lg:block'>
              <img
                src={ItMediaLogo.src}
                alt='ITmedia Inc.'
                className='ml-auto'
                width={ItMediaLogo.width}
                height={ItMediaLogo.height}
              />
            </div>
            <div className='hidden whitespace-nowrap text-xs lg:mt-1 lg:block'>
              発注ナビ株式会社はアイティメディア株式会社のグループ会社です。
            </div>
            <div className='text-sm lg:mt-1'>
              Copyright (c) hacchu navi Inc. All Rights Reserved
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
